import { render, staticRenderFns } from "./AffiliateLinkSection.vue?vue&type=template&id=2ae24407&"
import script from "./AffiliateLinkSection.vue?vue&type=script&lang=js&"
export * from "./AffiliateLinkSection.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports